module.exports = __webpack_public_path__ + "img/console49.737c3491.jpg";